
import HomeIcon from '@mui/icons-material/Home';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import MapIcon from '@mui/icons-material/Map';
import LoginIcon from '@mui/icons-material/Login';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import HouseIcon from '@mui/icons-material/House';
import FlightLandIcon from '@mui/icons-material/FlightLand';
import TodayIcon from '@mui/icons-material/Today';
import InventoryIcon from '@mui/icons-material/Inventory';
import ReceiptIcon from '@mui/icons-material/Receipt';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import FastfoodIcon from '@mui/icons-material/Fastfood';
import LineWeightIcon from '@mui/icons-material/LineWeight';
import WebhookIcon from '@mui/icons-material/Webhook';
import SearchIcon from '@mui/icons-material/Search';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import TableChartIcon from '@mui/icons-material/TableChart';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import FindInPageIcon from '@mui/icons-material/FindInPage';


export const IconMap = {
    home: <HomeIcon />,
    precios: <AttachMoneyIcon />,
    rutas: <MapIcon />,
    login: <LoginIcon />,
    salida: <FlightTakeoffIcon />,
    operacion: <WebhookIcon />,
    buscar: <SearchIcon />,
    'rutas en casas': <HouseIcon />,
    llegada: <FlightLandIcon />,
    planeacion: <TodayIcon />,
    'linea de tiempo': <InventoryIcon />,
    factura: <ReceiptIcon />,
    salir: <ExitToAppIcon />,
    PreciosHot: <WhatshotIcon />,
    gastos: <FastfoodIcon />,
    recargas: <LineWeightIcon />,
    metricas: <TableChartIcon />,
    clientela: <AssignmentIndIcon />,
    repositorio: <FindInPageIcon />
}